module.exports = __webpack_public_path__ + "shipping-car.15095d7c6224b46317fe201523b7678f.svg";